import React, { useEffect } from "react";
import {
  Grid,
  TextField,
  Typography,
  Box,
  useTheme,
} from "@mui/material";

interface Props {
  config: any;
  onChange: (field: string, value: any) => void;
}

const BgrPanoForm: React.FC<Props> = ({ config, onChange }) => {
  const theme = useTheme();
  const red = theme.palette.status.accent;

  // Always VUMO
  useEffect(() => {
    onChange("processor", "vumo");
  }, []);

  // Auto-generate apiEndpoint whenever profile changes
  useEffect(() => {
    const profile = config.profile || "default_interior_simple";
    const apiEndpoint = `https://api.vumography.vumo.ai/api/v1/process/single/${profile}`;
    onChange("apiEndpoint", apiEndpoint);
  }, [config.profile]);

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.background.paper,
        borderLeft: `3px solid ${red}`,
        borderRadius: 2,
        p: 2,
        mt: 1,
        boxShadow: "0 0 6px rgba(0,0,0,0.3)",
      }}
    >
      <Typography
        variant="subtitle1"
        sx={{
          mb: 2,
          fontWeight: 600,
          color: red,
          letterSpacing: 0.3,
        }}
      >
        Background Replace Pano Images
      </Typography>

      <Grid container spacing={2}>
        {/* Profile field */}
        <Grid item xs={12} sm={6}>
          <TextField
            label="Profile"
            fullWidth
            value={config.profile || ""}
            onChange={(e) => onChange("profile", e.target.value)}
            variant="outlined"
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": { borderColor: "#444" },
                "&:hover fieldset": { borderColor: red },
                "&.Mui-focused fieldset": { borderColor: red },
              },
            }}
          />
        </Grid>

        {/* Auto-generated API endpoint */}
        <Grid item xs={12}>
          <TextField
            label="API Endpoint (auto-generated)"
            fullWidth
            disabled
            value={config.apiEndpoint || ""}
            variant="outlined"
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": { borderColor: "#444" },
              },
              "& .MuiInputBase-input": { color: "#999" },
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default BgrPanoForm;
